import { ICommitmentException } from 'policyUI/classes/ICommitmentException';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const getOrderAsync = (orderId: string) => {
  return new Promise((resolve, reject) => {
    getOrderDetailsAsync(orderId).then(resolve).catch(reject);
  });
};
export const getCommitmentExceptionsAsync = (orderId: string) => {
  return new Promise((resolve, reject) => {
    getRequirementsExceptionsAsync(orderId).then(resolve).catch(reject);
  });
};

export const initializeCommitmentExceptionsAsync = (orderId: string) =>
  APIFactory(baseUrlService.ApiLocation).post(`/timber/api/internal/commitment-exceptions/v1/${orderId}/initialize`);

export const getCommitmentExceptionsAndInitializeAsync = async (orderId: string) => {
  let data = null;

  try {
    data = await getCommitmentExceptionsAsync(orderId);
  } catch (e: any) {
    if (e.response && e.response.status === 404) {
      await initializeCommitmentExceptionsAsync(orderId);
    } else {
      throw e;
    }
  }

  return data || (await getCommitmentExceptionsAsync(orderId));
};

export const getExceptionsTemplatesAsync = () =>
  APIFactory(baseUrlService.ApiLocation).get('/timber/api/internal/commitment-exceptions/v1/templates');
export const deleteCommitmentAsync = (orderId: string, itemIds: string[]) =>
  APIFactory(baseUrlService.ApiLocation).delete(`/timber/api/internal/commitment-exceptions/v1/${orderId}`, {
    data: itemIds,
  });

export const getOrderDetailsAsync = (orderId: string) =>
  APIFactory(baseUrlService.ApiLocation).get(`/timber/api/internal/orders/${orderId}`);
export const getRequirementsExceptionsAsync = (orderId: string) =>
  APIFactory(baseUrlService.ApiLocation).get(`/timber/api/internal/commitment-exceptions/v1/${orderId}`);
export const saveRequirementsExceptionsAsync = (orderId: string, newRequirementsExceptions: ICommitmentException[]) =>
  APIFactory(baseUrlService.ApiLocation).post(
    `/timber/api/internal/commitment-exceptions/v1/${orderId}`,
    newRequirementsExceptions
  );
